// import { useEffect, useState } from "react";
// import Header from "../Components/Header";
// import Footer from "../Components/Footer";
// import LogosSection from "../Components/LogosSection";
// import CardsCompo2 from "../Components/CardsCompo2";
// import CarouselSliderVetLearn from "../Components/CarouselSliderKaas";
// import { Carousel, CarouselItem, Row, Col, Container } from "react-bootstrap";
// import UserIcon from "../Images/User_icon (2).png";
// import h3 from "../Images/SliderImage2.jpg";
// import h2 from "../Images/SliderImage3.jpg";
// import StudentSdebar from "./StudentSdebar";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { Skeleton } from "@mui/material";
// import { FaArrowUp } from "react-icons/fa";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faYoutube,
//   faFacebookF,
//   faInstagram,
//   faLinkedinIn,
// } from "@fortawesome/free-brands-svg-icons";
// import { motion } from "framer-motion";

// const VETRINA_PURPLE = "#B8529E";
// const VETRINA_ORANGE = "#FF6600";
// const VETRINA_TEXT_SECONDARY = "#555";
// const VETRINA_BACKGROUND_LIGHT = "#f8f9fa";
// const VETRINA_ACCENT_LIGHT_PURPLE = "#f3e8f8";

// const heroSlidesData = [{ image: h2 }, { image: h3 }];

// // Array for social media links with corrected URLs
// const socialLinks = [
//   {
//     icon: faYoutube,
//     url: "https://www.youtube.com/channel/UCJ3r6VSr5EnxoKEQjYZoWIA",
//     label: "YouTube",
//   },
//   {
//     icon: faFacebookF,
//     url: "https://www.facebook.com/vetrinahealthcareenglish/",
//     label: "Facebook",
//   },
//   {
//     icon: faInstagram,
//     url: "https://www.instagram.com/vetrinahealthcare/",
//     label: "Instagram",
//   },
//   {
//     icon: faLinkedinIn,
//     url: "https://www.linkedin.com/company/vetrina-healthcare-pvt-ltd/",
//     label: "LinkedIn",
//   },
// ];

// export default function Home() {
//   const goToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

//   const navigate = useNavigate();
//   const redirect = (id) => navigate(`/Course/${id}`);

//   const [popularCourses, setPopularCourses] = useState([]);
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showBackToTop, setShowBackToTop] = useState(false);
//   const [sidebarExpanded, setSidebarExpanded] = useState(false);

//   const URL = "https://kaasbackend.vetrinahealthcare.com/";

//   const fetchPopularAndReviews = async () => {
//     setLoading(true);
//     try {
//       const popularResponse = await axios.get(`${URL}lms/popular/`);
//       const fetchedPopularCourses = popularResponse.data.popular_courses;
//       setPopularCourses(fetchedPopularCourses);

//       if (fetchedPopularCourses.length > 0) {
//         const reviewPromises = fetchedPopularCourses.map((course) =>
//           axios
//             .get(`${URL}lms/review/${course.course_id}/`)
//             .then((res) => ({
//               course_id: course.course_id,
//               reviews: res.data.reviews,
//             }))
//             .catch(() => ({ course_id: course.course_id, reviews: [] }))
//         );
//         const fetchedReviews = await Promise.all(reviewPromises);
//         const validReviews = fetchedReviews.filter((r) => r.reviews.length > 0);
//         setReviews(validReviews);
//       }
//     } catch (error) {
//       console.error("Error fetching courses/reviews:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPopularAndReviews();
//     const handleScroll = () => setShowBackToTop(window.scrollY > 300);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const vetLearnIntro = {
//     description1:
//       "VetLearn offers a secure, user-friendly platform that delivers 24/7 access to interactive training resources. It supports personalized learning journeys, facilitates skill-based assessments, and integrates with external tools.  ",
//     description2:
//       "Empowers both Trainers and Learners to meet learning goals effectively, contributing to professional growth through continuous development.",
//   };

//   // MODIFIED: Updated styles to match your friend's logic
//   const styles = {
//     carouselWrapper: {
//       position: "relative", // The positioning anchor for the icons
//       zIndex: 1,
//     },
//     socialIconsContainer: {
//   position: "absolute",
//   top: "20px",
//   right: "20px",
//   backgroundColor: "rgba(49, 42, 42, 0.7)",
//   padding: "8px 12px",
//   borderRadius: "30px",
//   display: "flex",
//   flexWrap: "wrap", // allow wrapping on small screens
//   gap: "20px",
//   zIndex: 99,
//   justifyContent: "center",
//   alignItems: "center",
//   maxWidth: "90vw", // prevent overflow
// },

//    socialIconLink: {
//   color: "white",
//   fontSize: "1rem",
//   transition: "transform 0.2s ease",
//   display: "inline-flex",
//   alignItems: "center",
//   justifyContent: "center",
// },

//     section: { padding: "60px 0" },
//     sectionTitle: {
//       textAlign: "center",
//       fontSize: "2rem",
//       fontWeight: "bold",
//       color: VETRINA_PURPLE,
//       marginBottom: "10px",
//     },
//     sectionTitleUnderline: {
//       display: "block",
//       width: "80px",
//       height: "4px",
//       background: `linear-gradient(90deg, ${VETRINA_ORANGE}, ${VETRINA_PURPLE})`,
//       borderRadius: "2px",
//       margin: "0 auto 40px",
//     },
//     helpItem: {
//     display: "flex",
//     gap: "15px",
//     alignItems: "flex-start",
//   },
//   helpIcon: {
//     fontSize: "40px",
//   },
//   helpTitle: {
//     fontSize: "18px",
//     fontWeight: "700",
//     marginBottom: "5px",
//     color: "#a23dbd",
//   },
//   helpText: {
//     fontSize: "14px",
//     lineHeight: "1.6",
//     color: "#555",
//   },
//     featureCard: {
//     background: "#fff",
//     borderRadius: "8px",
//     padding: "20px",
//     textAlign: "left",
//     boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//     minHeight: "200px",
//   },
//   featureCardTitle: {
//     fontSize: "18px",
//     fontWeight: "600",
//     marginBottom: "10px",
//     color: "#000",
//   },
//   featureCardText: {
//     fontSize: "14px",
//     lineHeight: "1.6",
//     color: "#555",
//   },
//     vetLearnIntroCard: {
//       background: VETRINA_ACCENT_LIGHT_PURPLE,
//       padding: "30px",
//       borderRadius: "15px",
//       boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
//       marginBottom: "80px",
//     },
//     vetLearnText: {
//       fontSize: "1.1rem",
//       lineHeight: "1.8",
//       color: VETRINA_TEXT_SECONDARY,
//       marginBottom: "15px",
//     },
//       highlightContainer: {
//     // background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
//     padding: "30px 20px",
//     borderRadius: "8px",
//     justifyContent:"center"
//   },
//   highlightHeadline: {
//   fontSize: "35px",
//   fontWeight: "700",
//   background: `linear-gradient(90deg, ${VETRINA_ORANGE}, ${VETRINA_PURPLE}, ${VETRINA_ORANGE})`,
//   backgroundSize: "200% auto",
//   WebkitBackgroundClip: "text",
//   WebkitTextFillColor: "transparent",
//   animation: "shimmer 4s linear infinite",
//   // marginBottom: "10px",
//   textAlign: "center",
// },

// highlightSubpoint: {
//   fontSize: "20px",
//   fontWeight: "400",
//   background: `linear-gradient(90deg, ${VETRINA_ORANGE}, ${VETRINA_PURPLE}, ${VETRINA_ORANGE})`,
//   backgroundSize: "200% auto",
//   WebkitBackgroundClip: "text",
//   WebkitTextFillColor: "transparent",
//   animation: "shimmer 4s linear infinite",
//   margin: 0,
//   textAlign: "center",
// },

//     reviewCarousel: {
//       backgroundColor: VETRINA_ACCENT_LIGHT_PURPLE,
//       padding: "40px 20px",
//       borderRadius: "20px",
//       boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
//     },
//     backToTopButton: {
//       position: "fixed",
//       bottom: "30px",
//       right: "30px",
//       zIndex: 1000,
//       backgroundColor: VETRINA_PURPLE,
//       color: "white",
//       border: "none",
//       borderRadius: "50%",
//       width: "50px",
//       height: "50px",
//       fontSize: "1.2rem",
//       cursor: "pointer",
//     },
//     homeSkillCard: {
//       display: "flex",
//       flexWrap: "wrap",
//       backgroundColor: "#fff",
//       padding: "30px",
//       borderRadius: "15px",
//       boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
//       margin: "40px auto",
//       maxWidth: "1100px",
//     },
//     homeContainer: { flex: "2 1 400px" },
//     homeHeading2: {
//       fontSize: "1.8rem",
//       fontWeight: "bold",
//       color: VETRINA_PURPLE,
//       marginBottom: "15px",
//     },
//     homeBlogContent: {
//       fontSize: "1.05rem",
//       lineHeight: "1.7",
//       color: VETRINA_TEXT_SECONDARY,
//     },
//   };

//   const getSocialIconsContainerStyle = () => ({
//   ...styles.socialIconsContainer,
//   flexDirection: window.innerWidth < 576 ? "row" : "row",
//   gap: window.innerWidth < 576 ? "10px" : "20px",
//   padding: window.innerWidth < 576 ? "6px 8px" : "8px 12px",
//   top: window.innerWidth < 576 ? "10px" : "20px",
//   right: window.innerWidth < 576 ? "10px" : "20px",
// });

//   return (
//     <div style={{ fontFamily: "'Poppins', sans-serif" }}>
//       <Header />
//       <div className="wrapper" style={{ display: "flex" }}>
//         <StudentSdebar onToggle={setSidebarExpanded} />
//         <div
//           className="main-content p-lg-4 p-md-3 p-2"
//           style={{
//             marginTop: window.innerWidth < 768 ? "60px" : "40px",
//             marginLeft: sidebarExpanded ? "260px" : "90px",
//             width: sidebarExpanded ? "calc(100% - 260px)" : "calc(100% - 90px)",
//             overflowY: "auto",
//             height: `calc(100vh - ${window.innerWidth < 768 ? 60 : 40}px)`,
//           }}
//         >
//           {/* MODIFIED: Implemented the wrapper logic */}
//           <div style={styles.carouselWrapper}>
//             {/* The social icons are now here, outside the Carousel */}
// <div style={getSocialIconsContainerStyle()}>
//               {socialLinks.map((link, i) => (
//                 <a
//                   key={i}
//                   href={link.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   aria-label={link.label}
//                   style={styles.socialIconLink}
//                 >
//                   <FontAwesomeIcon icon={link.icon} />
//                 </a>
//               ))}
//             </div>

//             <Carousel fade controls indicators interval={4000}>
//               {heroSlidesData.map((slide, index) => (
//                 // The position:relative is no longer needed here
//                 <Carousel.Item key={index}>
//                   <img
//                     src={slide.image}
//                     alt={`Slide ${index + 1}`}
//                     className="d-block w-100"
//                     style={{
//                       maxHeight: "80vh",
//                       objectFit: "cover",
//                       width: "100%",
//                     }}
//                   />
//                   {/* The social icons have been moved out from here */}
//                 </Carousel.Item>
//               ))}
//             </Carousel>
//           </div>

//           {/* --- The rest of your page content remains the same --- */}

//          <Container style={styles.section}>
//   <div style={styles.vetLearnIntroCard}>
//     <p style={styles.vetLearnText}>{vetLearnIntro.description1}</p>
//     <p style={styles.vetLearnText}>{vetLearnIntro.description2}</p>
//   </div>

//   <div style={styles.highlightContainer}>
//     <h2 style={styles.highlightHeadline}>
//       Empowering Learning. Enabling Growth.
//     </h2>
//     <p style={styles.highlightSubpoint}>
//       Empowering You to Learn, Experience, and Succeed.
//     </p>
//   </div>
// </Container>

//           {/* How We Help You Learn Section */}
// {/* How We Help You Learn Section */}
// <div className="container my-5">
//   <div
//     style={{
//       textAlign: "center",
//       marginTop: "50px",
//       marginBottom: "30px",
//     }}
//   >
//     <h3 style={{ ...styles.sectionTitle, fontSize: "2rem", color: "#a23dbd" }}>
//       How We Help You Learn!
//     </h3>
//     <div
//       style={{ ...styles.sectionTitleUnderline, width: "120px", background: "#a23dbd" }}
//     ></div>
//   </div>

//   <div className="row">
//     {[
//       {
//         icon: "📚",
//         title: "Access Courses",
//         text: "Explore a wide range of expert-designed modules tailored to real-world technical know courses.",
//       },
//       {
//         icon: "📈",
//         title: "Track Your Progress",
//         text: "View completed lessons, test scores, track course, check progress, perform tests, attend quizzes and analyze your performance.",
//       },
//       {
//         icon: "🧑",
//         title: "Learn Practically",
//         text: "Dive into content based on field experience, research, and best practices from industry leaders.",
//       },
//       {
//         icon: "🗓️",
//         title: "Stay Organized",
//         text: "Manage your learning schedule with deadlines, course calendars, and reminders.",
//       },
//       {
//         icon: "🎓",
//         title: "Earn Certificates",
//         text: "Get recognized for your achievements and use your certifications to grow professionally.",
//       },
//       {
//         icon: "🤝",
//         title: "Connect Peers",
//         text: "Connect, communicate, learn, and experience from everyone’s experience while learning from experts.",
//       },
//     ].map((item, index) => (
//       <div key={index} className="col-md-6 mb-4">
//         <div style={styles.helpItem}>
//           <div style={styles.helpIcon}>{item.icon}</div>
//           <div>
//             <h5 style={styles.helpTitle}>{item.title}</h5>
//             <p style={styles.helpText}>{item.text}</p>
//           </div>
//         </div>
//       </div>
//     ))}
//   </div>
// </div>

// {/* What You Will Gain from VetLearn Section */}
// <div className="container my-5">
//   <div
//     style={{
//       textAlign: "center",
//       marginTop: "50px",
//       marginBottom: "30px",
//     }}
//   >
//     <h3 style={{ ...styles.sectionTitle, fontSize: "2rem", color: "#a23dbd" }}>
//       What You Will Gain from VetLearn
//     </h3>
//     <div
//       style={{ ...styles.sectionTitleUnderline, width: "150px", background: "#a23dbd" }}
//     ></div>
//   </div>

//   <div className="row">
//     {[
//       {
//         icon: "🚀",
//         title: "Entrepreneurial Readiness",
//         text: "Build the knowledge and confidence needed to explore entrepreneurship opportunities in the livestock & companion animal industry.",
//       },
//       {
//         icon: "🔬",
//         title: "Scientific & Professional Skills",
//         text: "Develop thoroughness, reliability, efficiency, and critical thinking aligned with industry standards.",
//       },
//       {
//         icon: "📚",
//         title: "In-Depth Industry Knowledge",
//         text: "Gain advanced insights into livestock farming, industry insights, personal and professional development.",
//       },
//       {
//         icon: "📊",
//         title: "Analytical & Decision-Making Abilities",
//         text: "Learn to use modern tools and case-based approaches for real-time problem solving and decision making.",
//       },
//       {
//         icon: "🧑",
//         title: "Applied Practical Skills",
//         text: "Apply scientific principles to livestock farming through hands-on techniques and research-driven learning.",
//       },
//       {
//         icon: "🎓",
//         title: "Lifelong Learning Mindset",
//         text: "Foster a habit of continuous learning to stay updated with emerging trends, innovations, and practices in the veterinary and animal care sectors.",
//       },

//     ].map((item, index) => (
//       <div key={index} className="col-md-6 mb-4">
//         <div style={styles.helpItem}>
//           <div style={styles.helpIcon}>{item.icon}</div>
//           <div>
//             <h5 style={styles.helpTitle}>{item.title}</h5>
//             <p style={styles.helpText}>{item.text}</p>
//           </div>
//         </div>
//       </div>
//     ))}
//   </div>
// </div>

//           <div style={styles.homeSkillCard}>
//             <div style={styles.homeContainer}>
//               <h2 style={styles.homeHeading2}>ENHANCE YOUR SKILL NOW!</h2>
//               <p style={styles.homeBlogContent}>
//                 VetLearn enhances learning by offering personalized course
//                 recommendations...
//               </p>
//             </div>
//           </div>

//           {/* <Container style={styles.section}>
//             <h2 style={styles.sectionTitle}>Popular Professional Courses</h2>
//             <div style={styles.sectionTitleUnderline}></div>
//             <Row>
//               {loading
//                 ? Array.from({ length: 3 }).map((_, i) => (
//                     <Col sm={12} md={6} lg={4} className="mb-4" key={i}>
//                       <Skeleton
//                         variant="rectangular"
//                         width="100%"
//                         height={200}
//                         animation="wave"
//                       />
//                       <Skeleton
//                         width="80%"
//                         height={30}
//                         style={{ marginTop: 10 }}
//                       />
//                       <Skeleton
//                         width="60%"
//                         height={20}
//                         style={{ marginTop: 5 }}
//                       />
//                     </Col>
//                   ))
//                 : popularCourses.slice(0, 3).map((course, i) => (
//                     <Col sm={12} md={6} lg={4} className="mb-4" key={i}>
//                       <CardsCompo2
//                         imageUrl={course.featured_image || course.cover_img}
//                         price={`${course.price}`}
//                         title={course.title}
//                         description={course.description}
//                         actionCallback={() => redirect(course.course_id)}
//                         buttonBgColor={VETRINA_PURPLE}
//                         buttonTextColor="white"
//                         priceColor={VETRINA_ORANGE}
//                       />
//                     </Col>
//                   ))}
//             </Row>
//           </Container> */}

//           {/* {reviews.length > 0 && (
//             <Container style={styles.section}>
//               <h2 style={styles.sectionTitle}>What Our Learners Say</h2>
//               <div style={styles.sectionTitleUnderline}></div>
//               <div style={styles.reviewCarousel}>
//                 <Carousel fade controls={false} indicators interval={5000}>
//                   {reviews
//                     .flatMap((r) => r.reviews)
//                     .map((review, i) => (
//                       <CarouselItem key={i}>
//                         <CarouselSliderVetLearn
//                           personImg={review.user_profile_image || UserIcon}
//                           personNameStyle={{
//                             color: VETRINA_PURPLE,
//                             fontWeight: "bold",
//                             fontSize: "1.2rem",
//                           }}
//                           reviewTextStyle={{
//                             color: VETRINA_TEXT_SECONDARY,
//                             fontStyle: "italic",
//                             fontSize: "1rem",
//                           }}
//                         >
//                           <div
//                             style={{
//                               color: VETRINA_PURPLE,
//                               fontWeight: "bold",
//                             }}
//                           >
//                             {review.user || "Anonymous User"}
//                           </div>
//                           <p style={{ color: VETRINA_TEXT_SECONDARY }}>
//                             "{review.review}"
//                           </p>
//                           {review.rating && (
//                             <div
//                               style={{
//                                 marginTop: "10px",
//                                 color: VETRINA_ORANGE,
//                               }}
//                             >
//                               Rating: {"★".repeat(review.rating)}{" "}
//                               {"☆".repeat(5 - review.rating)}
//                             </div>
//                           )}
//                         </CarouselSliderVetLearn>
//                       </CarouselItem>
//                     ))}
//                 </Carousel>
//               </div>
//             </Container>
//           )} */}

//           {/* <div
//             style={{ ...styles.section, background: VETRINA_BACKGROUND_LIGHT }}
//           >
//             <Container>
//               <h2 style={styles.sectionTitle}>Our Partners & Affiliations</h2>
//               <div style={styles.sectionTitleUnderline}></div>
//               <LogosSection />
//             </Container>
//           </div> */}

//           {showBackToTop && (
//             <button
//               style={styles.backToTopButton}
//               onClick={goToTop}
//               title="Back to Top"
//             >
//               <FaArrowUp />
//             </button>
//           )}
//           <Footer />
//         </div>
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import LogosSection from "../Components/LogosSection";
import CardsCompo2 from "../Components/CardsCompo2";
import CarouselSliderVetLearn from "../Components/CarouselSliderKaas";
import { Carousel, CarouselItem, Row, Col, Container } from "react-bootstrap";
import UserIcon from "../Images/User_icon (2).png";
import h3 from "../Images/SliderImage2.jpg";
import h2 from "../Images/SliderImage3.jpg";
import StudentSdebar from "./StudentSdebar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "@mui/material";
import { FaArrowUp } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import AccessCourse from "../Images/AccessCourse.jpg";
import TrackProgress from "../Images/TrackProgress1.jpg";
import LearnPractically from "../Images/LearnPractically.jpg";
import StayOrganized from "../Images/StayOrganized1.jpg";
import EarnCertificates from "../Images/EarnCertificates.jpg";
import ConnectPeers from "../Images/ConnectPeers1.jpg";
import Entrepreneur from "../Images/Entrepreneur.jpg";
import SPSkills from "../Images/S&PSkills.jpg";
import IndustryKnowledge from "../Images/IndustryKnowledge.jpg";
import AppliedPracticalSkills from "../Images/AppliedPracticalSkills.jpg";
import LifelongLearning from "../Images/LifelongLearning1.jpg";
import AnalyticalDecision from "../Images/Analytical&Decision.jpg";

// No need for framer-motion in this component
// import { motion } from "framer-motion";

const VETRINA_PURPLE = "#B8529E";
const VETRINA_ORANGE = "#FF6600";
const VETRINA_TEXT_SECONDARY = "#555";
const VETRINA_BACKGROUND_LIGHT = "#f8f9fa";
const VETRINA_ACCENT_LIGHT_PURPLE = "#f3e8f8";

const heroSlidesData = [{ image: h2 }, { image: h3 }];

const socialLinks = [
  {
    icon: faYoutube,
    url: "https://www.youtube.com/channel/UCJ3r6VSr5EnxoKEQjYZoWIA",
    label: "YouTube",
  },
  {
    icon: faFacebookF,
    url: "https://www.facebook.com/vetrinahealthcareenglish/",
    label: "Facebook",
  },
  {
    icon: faInstagram,
    url: "https://www.instagram.com/vetrinahealthcare/",
    label: "Instagram",
  },
  {
    icon: faLinkedinIn,
    url: "https://www.linkedin.com/company/vetrina-healthcare-pvt-ltd/",
    label: "LinkedIn",
  },
];

export default function Home() {
  const goToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const navigate = useNavigate();
  const redirect = (id) => navigate(`/Course/${id}`);

  const [popularCourses, setPopularCourses] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  const URL = "https://kaasbackend.vetrinahealthcare.com/";

  // ... (useEffect and fetch functions remain the same) ...
  // const fetchPopularAndReviews = async () => {
  //   setLoading(true);
  //   try {
  //     const popularResponse = await axios.get(`${URL}lms/popular/`);
  //     const fetchedPopularCourses = popularResponse.data.popular_courses;
  //     setPopularCourses(fetchedPopularCourses);

  //     if (fetchedPopularCourses.length > 0) {
  //       const reviewPromises = fetchedPopularCourses.map((course) =>
  //         axios
  //           .get(`${URL}lms/review/${course.course_id}/`)
  //           .then((res) => ({
  //             course_id: course.course_id,
  //             reviews: res.data.reviews,
  //           }))
  //           .catch(() => ({ course_id: course.course_id, reviews: [] }))
  //       );
  //       const fetchedReviews = await Promise.all(reviewPromises);
  //       const validReviews = fetchedReviews.filter((r) => r.reviews.length > 0);
  //       setReviews(validReviews);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching courses/reviews:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

    // The function is renamed to reflect that it now only fetches popular courses.
  const fetchPopularAndReviews = async () => {
    setLoading(true);
    try {
      // The API call to get the list of popular courses remains the same.
      const popularResponse = await axios.get(`${URL}lms/popular/`);
      const fetchedPopularCourses = popularResponse.data.popular_courses;
      
      // Set the state with the fetched popular courses.
      setPopularCourses(fetchedPopularCourses);

      // All logic related to fetching reviews has been removed.

    } catch (error) {
      // The error message is updated for better clarity.
      console.error("Error fetching popular courses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPopularAndReviews();
    const handleScroll = () => setShowBackToTop(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const vetLearnIntro = {
    description1:
      "VetLearn offers a secure, user-friendly platform that delivers 24/7 access to interactive training resources. It supports personalized learning journeys, facilitates skill-based assessments, and integrates with external tools.  ",
    description2:
      "Empowers both Trainers and Learners to meet learning goals effectively, contributing to professional growth through continuous development.",
  };

  const helpItems = [
    {
      icon: AccessCourse,
      title: "Access Courses",
      text: "Explore a wide range of expert-designed modules tailored to real-world technical know courses.",
    },
    {
      icon: TrackProgress,
      title: "Track Your Progress",
      text: "View completed lessons, test scores, track course, check progress, perform tests, attend quizzes and analyze your performance.",
    },
    {
      icon: LearnPractically,
      title: "Learn Practically",
      text: "Dive into content based on field experience, research, and best practices from industry leaders.",
    },
    {
      icon: StayOrganized,
      title: "Stay Organized",
      text: "Manage your learning schedule with deadlines, course calendars, and reminders.",
    },
    {
      icon: EarnCertificates,
      title: "Earn Certificates",
      text: "Get recognized for your achievements and use your certifications to grow professionally.",
    },
    {
      icon: ConnectPeers,
      title: "Connect Peers",
      text: "Connect, communicate, learn, and experience from everyone’s experience while learning from experts.",
    },
  ];
  const styles = {
    // MODIFIED: This is the single source of truth for spacing BETWEEN sections.
    sectionWrapper: {
      padding: "40px 0",
    },
    carouselWrapper: {
      position: "relative",
      zIndex: 1,
    },
    socialIconsContainer: {
      position: "absolute",
      top: "20px",
      right: "20px",
      backgroundColor: "rgba(49, 42, 42, 0.7)",
      padding: "8px 12px",
      borderRadius: "30px",
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      zIndex: 99,
      justifyContent: "center",
      alignItems: "center",
      maxWidth: "90vw",
    },
    socialIconLink: {
      color: "white",
      fontSize: "1rem",
      transition: "transform 0.2s ease",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
    // MODIFIED: This group now defines the common header style WITHIN a section.
    sectionHeader: {
      textAlign: "center",
      marginBottom: "50px", // Creates space between the title and the content below it.
    },
    sectionTitle: {
      fontSize: "2rem",
      fontWeight: "bold",
      color: "#a23dbd",
      marginBottom: "10px",
    },
    sectionTitleUnderline: {
      display: "block",
      height: "4px",
      background: "#a23dbd",
      borderRadius: "2px",
      margin: "0 auto",
    },
    helpItem: {
      display: "flex",
      gap: "15px",
      alignItems: "flex-start",
    },
    helpIcon: {
      fontSize: "40px",
    },
    helpTitle: {
      fontSize: "18px",
      fontWeight: "700",
      marginBottom: "5px",
      color: "#a23dbd",
    },
    helpText: {
      fontSize: "14px",
      lineHeight: "1.6",
      color: "#555",
    },
    vetLearnIntroCard: {
      background: VETRINA_ACCENT_LIGHT_PURPLE,
      padding: "30px",
      borderRadius: "15px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
      // MODIFIED: Removed all margins. The parent wrapper controls spacing.
    },
    vetLearnText: {
      fontSize: "1.1rem",
      lineHeight: "1.8",
      color: VETRINA_TEXT_SECONDARY,
      marginBottom: "15px",
    },
    highlightContainer: {
      padding: "20px 10px",
      borderRadius: "8px",
      justifyContent: "center",
    },
    highlightHeadline: {
      fontSize: "45px",
      fontWeight: "700",
      background: `linear-gradient(90deg, ${VETRINA_ORANGE}, ${VETRINA_PURPLE}, ${VETRINA_ORANGE})`,
      backgroundSize: "200% auto",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      animation: "shimmer 4s linear infinite",
      textAlign: "center",
    },
    highlightSubpoint: {
      fontSize: "25px",
      fontWeight: "400",
      background: `linear-gradient(90deg, ${VETRINA_ORANGE}, ${VETRINA_PURPLE}, ${VETRINA_ORANGE})`,
      backgroundSize: "200% auto",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      animation: "shimmer 4s linear infinite",
      margin: 0,
      textAlign: "center",
    },
    reviewCarousel: {
      backgroundColor: VETRINA_ACCENT_LIGHT_PURPLE,
      padding: "40px 20px",
      borderRadius: "20px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    },
    backToTopButton: {
      position: "fixed",
      bottom: "30px",
      right: "30px",
      zIndex: 1000,
      backgroundColor: VETRINA_PURPLE,
      color: "white",
      border: "none",
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      fontSize: "1.2rem",
      cursor: "pointer",
    },
    homeSkillCard: {
      display: "flex",
      flexWrap: "wrap",
      backgroundColor: "#fff",
      padding: "30px",
      borderRadius: "15px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
      margin: "0 auto", // Keep horizontal auto margin
      maxWidth: "1100px",
    },
    homeContainer: { flex: "2 1 400px" },
    homeHeading2: {
      fontSize: "1.8rem",
      fontWeight: "bold",
      color: VETRINA_PURPLE,
      marginBottom: "15px",
    },
    homeBlogContent: {
      fontSize: "1.05rem",
      lineHeight: "1.7",
      color: VETRINA_TEXT_SECONDARY,
    },
    helpItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "15px",
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      height: "100%",
    },
    helpIcon: {
      flexShrink: 0,
    },
    helpImage: {
      width: "40px",
      height: "40px",
      objectFit: "contain",
    },
    helpTitle: {
      fontSize: "1.2rem",
      fontWeight: "600",
      marginBottom: "8px",
    },
    helpText: {
      fontSize: "0.95rem",
      color: "#555",
      margin: 0,
    },
  };

  const getSocialIconsContainerStyle = () => ({
    // ... (This function remains the same) ...
    ...styles.socialIconsContainer,
    flexDirection: window.innerWidth < 576 ? "row" : "row",
    gap: window.innerWidth < 576 ? "10px" : "20px",
    padding: window.innerWidth < 576 ? "6px 8px" : "8px 12px",
    top: window.innerWidth < 576 ? "10px" : "20px",
    right: window.innerWidth < 576 ? "10px" : "20px",
  });

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif" }}>
      <Header />
      <div className="wrapper" style={{ display: "flex" }}>
        <StudentSdebar onToggle={setSidebarExpanded} />
        <div
          className="main-content p-lg-4 p-md-3 p-2"
          style={{
            marginTop: window.innerWidth < 768 ? "60px" : "40px",
            marginLeft: sidebarExpanded ? "260px" : "60px",
            width: sidebarExpanded ? "calc(100% - 260px)" : "calc(100% - 60px)",
            overflowY: "auto",
            height: `calc(100vh - ${window.innerWidth < 768 ? 60 : 40}px)`,
          }}
        >
          {/* --- HERO CAROUSEL (No wrapper needed, it's the top element) --- */}
          <div style={styles.carouselWrapper}>
            <div style={getSocialIconsContainerStyle()}>
              {socialLinks.map((link, i) => (
                <a
                  key={i}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                  style={styles.socialIconLink}
                >
                  <FontAwesomeIcon icon={link.icon} />
                </a>
              ))}
            </div>
            <Carousel fade controls indicators interval={4000}>
              {heroSlidesData.map((slide, index) => (
                <Carousel.Item key={index}>
                  <img
                    src={slide.image}
                    alt={`Slide ${index + 1}`}
                    className="d-block w-100"
                    style={{
                      maxHeight: "80vh",
                      objectFit: "cover",
                      width: "100%",
                    }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          {/* --- VETLEARN INTRO SECTION --- */}
          <div style={styles.sectionWrapper}>
            <Container>
              <div style={styles.vetLearnIntroCard}>
                <p style={styles.vetLearnText}>{vetLearnIntro.description1}</p>
                <p style={styles.vetLearnText}>{vetLearnIntro.description2}</p>
              </div>
            </Container>
          </div>

          {/* --- HIGHLIGHT TEXT SECTION --- */}
          <div style={styles.sectionWrapper}>
            <Container>
              <div style={styles.highlightContainer}>
                <h2 style={styles.highlightHeadline}>
                  Empowering Learning. Enabling Growth.
                </h2>
                <p style={styles.highlightSubpoint}>
                  Empowering You to Learn, Experience, and Succeed.
                </p>
              </div>
            </Container>
          </div>

          {/* --- HOW WE HELP YOU LEARN SECTION --- */}
          <div style={styles.sectionWrapper}>
            <Container>
              <div style={styles.sectionHeader}>
                <h3 style={styles.sectionTitle}>How We Help You Learn!</h3>
                <div
                  style={{ ...styles.sectionTitleUnderline, width: "120px" }}
                ></div>
              </div>
              <Row>
                {helpItems.map((item, index) => (
                  <Col md={6} className="mb-4" key={index}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start", // align top!
                        gap: "1rem",
                        padding: "1rem",
                        borderRadius: "8px",
                      }}
                    >
                      <div
                        style={{
                          flexShrink: 0,
                          borderRadius: "12px",
                          overflow: "hidden",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                          background: "#fff",
                        }}
                      >
                        <img
                          src={item.icon}
                          alt={item.title}
                          style={{
                            display: "block",
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div>
                        <h5
                          style={{
                            color: "#A73D8E",
                            fontWeight: "600",
                            margin: 0,
                            marginBottom: "0.25rem",
                          }}
                        >
                          {item.title}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            color: "#333",
                            fontSize: "0.95rem",
                            lineHeight: "1.5",
                          }}
                        >
                          {item.text}
                        </p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Container>
          </div>

          {/* --- WHAT YOU WILL GAIN SECTION --- */}
          <div style={styles.sectionWrapper}>
            <Container>
              <div style={styles.sectionHeader}>
                <h3 style={styles.sectionTitle}>
                  What You Will Gain from VetLearn
                </h3>
                <div
                  style={{ ...styles.sectionTitleUnderline, width: "150px" }}
                ></div>
              </div>
              <Row>
                {[
                  {
                    icon: Entrepreneur,
                    title: "Entrepreneurial Readiness",
                    text: "Build the knowledge and confidence needed to explore entrepreneurship opportunities in the livestock & companion animal industry.",
                  },
                  {
                    icon: SPSkills,
                    title: "Scientific & Professional Skills",
                    text: "Develop thoroughness, reliability, efficiency, and critical thinking aligned with industry standards.",
                  },
                  {
                    icon: IndustryKnowledge,
                    title: "In-Depth Industry Knowledge",
                    text: "Gain advanced insights into livestock farming, industry insights, personal and professional development.",
                  },
                  {
                    icon: AnalyticalDecision,
                    title: "Analytical & Decision-Making Abilities",
                    text: "Learn to use modern tools and case-based approaches for real-time problem solving and decision making.",
                  },
                  {
                    icon: AppliedPracticalSkills,
                    title: "Applied Practical Skills",
                    text: "Apply scientific principles to livestock farming through hands-on techniques and research-driven learning.",
                  },
                  {
                    icon: LifelongLearning,
                    title: "Lifelong Learning Mindset",
                    text: "Foster a habit of continuous learning to stay updated with emerging trends, innovations, and practices in the veterinary and animal care sectors.",
                  },
                ].map((item, index) => (
                  <Col md={6} className="mb-4" key={index}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "1rem",
                        padding: "1rem",
                        borderRadius: "8px",
                      }}
                    >
                      <div
                        style={{
                          flexShrink: 0,
                          width: "60px",
                          height: "60px",
                          borderRadius: "12px",
                          overflow: "hidden",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                          background: "#fff",
                        }}
                      >
                        <img
                          src={item.icon}
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </div>
                      <div>
                        <h5
                          style={{
                            color: "#A73D8E",
                            fontWeight: "600",
                            margin: 0,
                            marginBottom: "0.25rem",
                          }}
                        >
                          {item.title}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            color: "#333",
                            fontSize: "0.95rem",
                            lineHeight: "1.5",
                          }}
                        >
                          {item.text}
                        </p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Container>
          </div>

          {/* --- ENHANCE YOUR SKILL SECTION --- */}
          <div style={styles.sectionWrapper}>
            <Container>
              <div style={styles.homeSkillCard}>
                <div style={styles.homeContainer}>
                  <h2 style={styles.homeHeading2}>ENHANCE YOUR SKILL NOW!</h2>
                  <p style={styles.homeBlogContent}>
                    VetLearn enhances learning by offering personalized course
                    recommendations...
                  </p>
                </div>
              </div>
            </Container>
          </div>

          {/* --- FOOTER & BACK TO TOP BUTTON --- */}
          {showBackToTop && (
            <button
              style={styles.backToTopButton}
              onClick={goToTop}
              title="Back to Top"
            >
              <FaArrowUp />
            </button>
          )}
          <Footer />
        </div>
      </div>
    </div>
  );
}
